// extracted by mini-css-extract-plugin
module.exports = {"eventInfo":"EventInfo_eventInfo__3hqZa","name":"EventInfo_name__UTxNY"};